import { FormatterImpl } from './formatImpl';

export function createFormatter() {
    return new FormatterImpl();
}
